<template>
  <div class="row">
    <modal :show.sync="modals.logs" type="large">
      <template slot="header">
        <h3 class="modal-title" id="exampleModalLabel">
          Gateway logs data for {{ modals.name }}
        </h3>
      </template>
      <div>
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <!-- <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search Device"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input> -->
            </div>
            <el-table
              :data="logsdata"
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                :min-width="150"
                prop="eventtime"
                label="Event time"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="context"
                label="Context"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="message"
                label="Message"
              ></el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </modal>
    <!-- heading & button -->
    <card>
      <template>
        <div class="col-lg-12 col-md-6">
          <!-- <card type="chart"> -->
          <!-- <template slot="header"> -->
          <div class="row">
            <div class="col-lg-4">
              <h3 class="card-title brightness">
                <div class="text-center text-md-left">
                  <!-- <base-button
                    type="success"
                    @click.native="modals.notice = true"
                    >Add Device</base-button
                  >&nbsp;
                  <base-button
                    type="success"
                    @click.native="modals.upload = true"
                    >Import CSV</base-button
                  > -->
                </div>
                <!-- <span>{{moment(date).format('YYYY-MM-DD')}}</span> -->
                <!-- Add device modal -->

                <!-- upload csv modal -->

                <div slot="footer"></div>
              </h3>
            </div>
          </div>
          <!-- </template> -->
          <!-- </card> -->
        </div>

        <!-- Gateway -->
        <div class="col-lg-12 col-md">
          <!-- tables -->
          <div>
            <!-- pagination -->
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <el-select
                class="select-primary mb-3 pagination-select d-none d-sm-block"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>

              <base-input type="success">
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <!-- table data -->
            <el-table
              :data="queriedData"
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                min-width="150"
                label="Gateway Name"
                property="gatewayname"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                label="Gateway Type"
                property="gatewaytype"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Last ping"
                property="lastping"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Last Online"
                property="lastonline"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Status"
                property="status"
              ></el-table-column>

              <el-table-column :min-width="100" align="right" label="Actions">
                <div slot-scope="props">
                  <el-tooltip
                    content="Ping gateway"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click="getRow('PING', props)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-sound-wave"></i>
                    </base-button>
                  </el-tooltip>
                  <!-- <el-tooltip
                    content="Display logs"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click="getRow('LOG', props)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-align-left-2"></i>
                    </base-button>
                  </el-tooltip> -->
                </div>
              </el-table-column>
            </el-table>
          </div>

          <!-- modal to edit device details -->
          <modal
            :show.sync="modals.edit"
            footer-classes="justify-content-center"
            type="notice"
          >
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <div class="row justify-content-center mt-12">
                      <div class="col-sm-12">
                        <div>
                          <h3 style="color: #344675">Device Information</h3>
                          <base-input
                            v-model="device.devicename"
                            type="text"
                            label="Device Name"
                            placeholder="Device Name"
                          ></base-input>
                          <base-input
                            label="Device Type"
                            placeholder="Device Type"
                            v-model="device.devicetype"
                            type="text"
                            disabled
                          ></base-input>
                          <base-input
                            v-model="device.lat"
                            type="text"
                            label="Latitude"
                            placeholder="Latitude"
                          ></base-input>
                          <base-input
                            v-model="device.lon"
                            type="text"
                            label="Longitude"
                            placeholder="Longitude"
                          ></base-input>
                          <base-input label="Commission Date">
                            <el-date-picker
                              v-model="device.commdate"
                              type="date"
                              label="Commission Date"
                              placeholder="Commission Date"
                            ></el-date-picker>
                          </base-input>
                          <base-input label="Warranty">
                            <el-date-picker
                              v-model="device.warranty"
                              type="date"
                              label="Warranty"
                              placeholder="Warranty"
                            ></el-date-picker>
                          </base-input>
                        </div>
                      </div>
                      <div>
                        <base-button
                          class="mt-3"
                          native-type="submit"
                          type="success"
                          @click.native="handleEdit()"
                          >Submit</base-button
                        >
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="modals.edit = false"
                          >Cancel</base-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </modal>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
          <!-- </h3>-->
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Modal, BasePagination } from "src/components";
import { Slider, BaseSwitch } from "src/components/index";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import users from "./users"; //read users from this file
import Fuse from "fuse.js";

var moment = require("moment"); // Change date format

export default {
  components: {
    [DatePicker.name]: DatePicker,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },
  data() {
    return {
      fileName: "No File Selected",
      select: {
        timezone: [
          {
            label: "(GMT+08:00) Kuala Lumpur, Singapore",
            value: "Asia/Kuala_Lumpur",
          },
          { label: "(GMT-12:00) International Date Line West", value: -12 },
          { label: "(GMT-11:00) Midway Island, Samoa", value: -11 },
          { label: "(GMT-10:00) Hawaii", value: -10 },
          { label: "(GMT-09:00) Alaska", value: -9 },
          { label: "(GMT-08:00) Pacific Time (US & Canada)", value: -8 },
          {
            label: "(GMT-08:00) Tijuana, Baja California",
            value: "America/Tijuana",
          },
          { label: "(GMT-07:00) Arizona", value: "US/Arizona" },
          {
            label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
            value: "America/Chihuahua",
          },
          {
            label: "(GMT-07:00) Mountain Time (US & Canada)",
            value: "US/Mountain",
          },
          { label: "(GMT-06:00) Central America", value: "America/Managua" },
          {
            label: "(GMT-06:00) Central Time (US & Canada)",
            value: "US/Central",
          },
          {
            label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
            value: "America/Mexico_City",
          },
          { label: "(GMT-06:00) Saskatchewan", value: "Canada/Saskatchewan" },
          {
            label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
            value: "America/Bogota",
          },
          {
            label: "(GMT-05:00) Eastern Time (US & Canada)",
            value: "US/Eastern",
          },
          { label: "(GMT-05:00) Indiana (East)", value: "US/East-Indiana" },
          {
            label: "(GMT-04:00) Atlantic Time (Canada)",
            value: "Canada/Atlantic",
          },
          { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
          { label: "(GMT-04:00) Manaus", value: "America/Manaus" },
          { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
          { label: "(GMT-03:30) Newfoundland", value: "Canada/Newfoundland" },
          { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
          {
            label: "(GMT-03:00) Buenos Aires, Georgetown",
            value: "America/Argentina/Buenos_Aires",
          },
          { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
          { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
          { label: "(GMT-02:00) Mid-Atlantic", value: "America/Noronha" },
          { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
          { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
          {
            label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
            value: "Africa/Casablanca",
          },
          {
            label:
              "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
            value: "Etc/Greenwich",
          },
          {
            label:
              "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            value: "Europe/Amsterdam",
          },
          {
            label:
              "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            value: "Europe/Belgrade",
          },
          {
            label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
            value: "Europe/Brussels",
          },
          {
            label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            value: "Europe/Sarajevo",
          },
          { label: "(GMT+01:00) West Central Africa", value: "Africa/Lagos" },
          { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
          {
            label: "(GMT+02:00) Athens, Bucharest, Istanbul",
            value: "Europe/Athens",
          },
          { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
          { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
          { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
          {
            label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
            value: "Europe/Helsinki",
          },
          { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
          { label: "(GMT+02:00) Minsk", value: "Europe/Minsk" },
          { label: "(GMT+02:00) Windhoek", value: "Africa/Windhoek" },
          {
            label: "(GMT+03:00) Kuwait, Riyadh, Baghdad",
            value: "Asia/Kuwait",
          },
          {
            label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
            value: "Europe/Moscow",
          },
          { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
          { label: "(GMT+03:00) Tbilisi", value: "Asia/Tbilisi" },
          { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
          { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
          { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
          { label: "(GMT+04:00) Yerevan", value: "Asia/Yerevan" },
          { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
          { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
          {
            label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
            value: "Asia/Karachi",
          },
          {
            label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            value: "Asia/Calcutta",
          },
          { label: "(GMT+05:30) Sri Jayawardenapura", value: "Asia/Calcutta" },
          { label: "(GMT+05:45) Kathmandu", value: "Asia/Katmandu" },
          { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
          { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
          { label: "(GMT+06:30) Yangon (Rangoon)", value: "Asia/Rangoon" },
          {
            label: "(GMT+07:00) Bangkok, Hanoi, Jakarta",
            value: "Asia/Bangkok",
          },
          { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
          {
            label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            value: "Asia/Hong_Kong",
          },
          { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
          { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
          { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
          { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
          { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
          { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
          { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
          { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
          { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
          {
            label: "(GMT+10:00) Canberra, Melbourne, Sydney",
            value: "Australia/Canberra",
          },
          { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
          { label: "(GMT+10:00) Guam, Port Moresby", value: "Pacific/Guam" },
          { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
          {
            label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
            value: "Asia/Magadan",
          },
          {
            label: "(GMT+12:00) Auckland, Wellington",
            value: "Pacific/Auckland",
          },
          {
            label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
            value: "Pacific/Fiji",
          },
          { label: "(GMT+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
        ],

        timez: "",
      },
      logsdata: [],
      onSpin: false,
      deviceCSV: "",
      devices: [],
      device: {
        devicetypes: [
          { value: "nbiot", label: "Nbiot" },
          { value: "lora", label: "Lora" },
        ],
        deviceid: "",
        devicename: "",
        devicetype: "",
        devicetoken: "",
        loraAppKey: "",
        devicedesc: "",
        deviceattr: "",
        CreatedAt: "",
        UpdatedAt: "",
        lat: "",
        lon: "",
        commdate: "",
        warranty: "",
      },
      selects: {
        simple: "",
      },
      datePicker: "",
      modals: {
        name: null,
        logs: false,
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["gatewayname", "gatewaytype"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      getRowData: "",
      payloadCSV: [],
    };
  },
  methods: {
    closeModal() {
      this.modals.notice = false;
    },
    closeModal2() {
      this.modals.notice2 = false;
    },
    getGatewayList() {
      this.$http
        .get(":8003/api/v1/gateway")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
            console.log(res.message.length);
          } else {
            for (let i = 0; i < res.message.length; i++) {
              console.log(res.message);
              let obj = {};
              obj["gatewayname"] = res.message[i].GatewayName;
              obj["gatewaytype"] = res.message[i].GatewayType;
              obj["gatewayid"] = res.message[i].GatewayID;
              obj["lastping"] = moment(res.message[i].LastPing).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              obj["lastonline"] = moment(res.message[i].LastOnline).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              obj["status"] = res.message[i].Status == 1 ? "Online" : "Offline";
              this.tableData.push(obj);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGatewayLog(gatewayid, rowid) {
      console.log(gatewayid);
      console.log(rowid);
      this.$http
        .get(":8007/api/v1/log/" + gatewayid + "")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
            console.log(res.message.length);
          } else {
            this.modals.name = rowid.row.gatewayname;
            res.message.map((a) => {
              let obj = {};
              obj["eventtime"] = moment(a.createdAt).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              obj["context"] = a.LogContext;
              obj["message"] = a.LogMessage;
              this.logsdata.push(obj);
            });
            this.modals.logs = true;

            console.log(this.modals.name);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pingGateway(gatewayid, rowid) {
      this.tableData[rowid].status = "Processing....";
      console.log(gatewayid);
      console.log(rowid);
      this.$http
        .get(":8003/api/v1/gateway/" + gatewayid + "/ping")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
            console.log(res.message.length);
          } else {
            console.log(res.message);
            this.tableData[rowid].status =
              res.message.Status == 1 ? "Online" : "Offline";
            this.tableData[rowid].lastping = moment(
              res.message.LastPing
            ).format("YYYY-MM-DD HH:mm:ss");
            this.tableData[rowid].lastonline = moment(
              res.message.LastOnline
            ).format("YYYY-MM-DD HH:mm:ss");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRow(ctx, props) {
      console.log(props);
      if (ctx === "PING") {
        this.pingGateway(props.row.gatewayid, props.$index);
      } else {
        this.getGatewayLog(props.row.gatewayid, props);
      }
    },
  },
  computed: {
    queriedData() {
      let result = this.tableData;

      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  created() {
    this.getGatewayList();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["gatewayname", "gatewaytype"],
      threshold: 0.3,
    });
  },
  watch: {
    searchQuery(value) {
      let result = this.devices;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.head h3 {
  display: inline;
  padding-bottom: 10px;
}
.brightness p {
  display: inline;
}
.bright slider {
  display: inline;
}
.chartButton {
  text-align: right;
}
#fileName {
  margin: 3%;
  color: black;
  font-weight: bold;
}
</style>
f
